<div class="footer-section">
  <div class="footer-links">
    @if (brand.legalUrls) {
      <div class="footer-link-wrapper">
        <a class="footer-link" [href]="brand.legalUrls.privacyPolicy" rel="noopener" target="_blank" title="Privacy Policy"
          >Privacy Policy</a
        >
      </div>

      <div class="footer-link-wrapper">
        <a class="footer-link" [href]="brand.legalUrls.terms" rel="noopener" target="_blank" title="Terms of Use">Terms</a>
      </div>
    } @else {
      <div class="footer-link-wrapper">
        <button class="footer-link" (click)="onPrivacyPolicyClick()" title="Privacy Policy">Privacy Policy</button>
      </div>

      <div class="footer-link-wrapper">
        <button class="footer-link" (click)="onTermsConditionsClick()" title="Terms & Conditions">Terms</button>
      </div>
    }

    <!-- Insights Dashboard temporarily hidden: insights.rocketkor.net is disabled.
         Restore this block once the domain is back online. -->
    <!-- <div class="footer-link-wrapper">
      <a class="footer-link" href="https://insights.rocketkor.net" rel="noopener" target="_blank" title="Insights Dashboard"
        >Insights Dashboard</a
      >
    </div> -->

    <div class="footer-link-wrapper">
      <a class="footer-link" [href]="envConfig.docsUrl" rel="noopener" target="_blank" title="API Documentation">API Documentation</a>
    </div>
  </div>

  <div class="footer-copyright">
    <span>&copy; {{ currentYear }} {{ brand.companyName }} All rights reserved.</span>

    <app-version></app-version>
  </div>
</div>
